import React, { useState, useEffect } from "react";
import { Tree } from "antd";
import { CaretDownOutlined, CaretRightOutlined } from "@ant-design/icons";
import { TPrivilege } from "../../types/config";
import { STAKE_HOLDERS } from "../../utils/constants";

// Helper function to extract privilegeUniqueIds from an array of privilege objects
const getPrivilegeUniqueIds = (privileges: any[]) => {
  return privileges.map((privilege) => privilege.privilegeUniqueId);
};

const PrivilegeMapper: React.FC<{
  selectedStakeHolder: string | undefined;
  menuHierarchy: any[];
  preSelectedPrivileges: any[]; // Now an array of objects
  onPrivilegesChange: (checkedPrivileges: any[]) => void;
}> = ({
  menuHierarchy,
  preSelectedPrivileges,
  onPrivilegesChange,
  selectedStakeHolder = "",
}) => {
  const [checkedKeys, setCheckedKeys] = useState<string[]>(
    getPrivilegeUniqueIds(preSelectedPrivileges)
  );

  useEffect(() => {
    setCheckedKeys([]);
  }, [selectedStakeHolder]);

  // Recursively transform the menuHierarchy into TreeNode structure
  const generateTreeNodes = (data: any[]) => {
    return data.map((menuItem) => {
      const { children = [], privileges = [] } = menuItem;
      console.log({ privileges });
      // If there are privileges, generate checkboxes for them
      const privilegeNodes = privileges.map((privilege: TPrivilege) => ({
        title: <>{privilege.name}</>,
        key: privilege.privilegeUniqueId,
        isLeaf: true,
        privilege, // Add the privilege object to node for easier access
        disabled:
          selectedStakeHolder === STAKE_HOLDERS.IDEX
            ? !privilege.idex // Negate to disable if 0
            : selectedStakeHolder === STAKE_HOLDERS.CUSTOMER
              ? !privilege.customer
              : false,
      }));

      // If the item has children, generate nested nodes
      const childNodes = generateTreeNodes(children) as any;

      return {
        title: (
          <h4 style={{ fontFamily: "Montserrat-SemiBold" }}>
            {menuItem.dispName}
          </h4>
        ),
        key: menuItem.menuUniqueId,
        children: [...privilegeNodes, ...childNodes],
      };
    });
  };

  // Convert the menuHierarchy into AntD Tree nodes
  const treeData = generateTreeNodes(menuHierarchy);

  // Handle checking/unchecking of tree nodes
  const handleCheck = (checkedKeysValue: any, info: any) => {
    setCheckedKeys(checkedKeysValue);

    // Extract privileges from checked nodes
    const checkedPrivileges = info.checkedNodes
      .filter((node: any) => node.privilege) // Only include nodes with privileges
      .map((node: any) => node.privilege); // Map to privilege object

    // Send checked privileges back to the parent component
    onPrivilegesChange(checkedPrivileges);
  };

  useEffect(() => {
    // Set the initial checked keys when the component mounts
    setCheckedKeys(getPrivilegeUniqueIds(preSelectedPrivileges));
  }, [preSelectedPrivileges]);

  return (
    <div style={{ height: "72%", overflowY: "auto" }}>
      <Tree
        checkable
        checkedKeys={checkedKeys}
        onCheck={handleCheck}
        defaultExpandAll
        switcherIcon={({ expanded }) =>
          expanded ? <CaretDownOutlined /> : <CaretRightOutlined />
        }
        treeData={treeData}
      />
    </div>
  );
};

export default PrivilegeMapper;
